import React, { useState } from 'react';
import { MessageCircle, Send, Heart, Image } from 'lucide-react';

export const ParentCommModule: React.FC = () => {
  const [messages, setMessages] = useState([
    { id: '1', sender: 'Therapist Sarah', text: 'Rahul did a fantastic job today using the AAC board during storytime!', time: '02:30 PM' },
    { id: '2', sender: 'Parent (You)', text: 'Thank you! We will practice the home flashcards tonight.', time: '02:35 PM' },
  ]);
  const [input, setInput] = useState('');

  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    if (!input) return;
    setMessages([...messages, {
      id: Date.now().toString(),
      sender: 'Parent (You)',
      text: input,
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    }]);
    setInput('');
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-orange-100 text-orange-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Seesaw & ClassDojo Benchmark
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Parent-Teacher-Therapist Communication</h2>
          <p className="text-xs text-slate-500">Secure messenger, home practice video sharing, and daily student check-in</p>
        </div>
      </div>

      <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-4">
        <div className="space-y-2.5 max-h-60 overflow-y-auto">
          {messages.map((msg) => (
            <div key={msg.id} className={`p-3 rounded-lg text-xs max-w-md ${
              msg.sender.includes('You') 
                ? 'bg-blue-600 text-white ml-auto' 
                : 'bg-white text-slate-900 border border-slate-200'
            }`}>
              <div className="font-bold opacity-80 text-[10px]">{msg.sender} • {msg.time}</div>
              <div className="mt-1">{msg.text}</div>
            </div>
          ))}
        </div>

        <form onSubmit={handleSend} className="flex gap-2 pt-2">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type message to therapist..."
            className="flex-1 px-3 py-2 border border-slate-300 rounded-lg text-xs focus:ring-2 focus:ring-orange-500 focus:outline-none bg-white"
          />
          <button type="submit" className="px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white font-bold rounded-lg text-xs flex items-center gap-1">
            <Send className="w-3.5 h-3.5" />
            Send
          </button>
        </form>
      </div>
    </div>
  );
};
